import { Box, Typography } from '@mui/material';

export default function NotFoundPage() {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="100vh"
    >
      <Typography variant="h4" color="text.secondary">
        404 - Página não encontrada
      </Typography>
    </Box>
  );
}
